import api from './api';

class CityService {
  /**
   * Get all cities
   * @returns {Promise} API response
   */
  async getAllCities() {
    try {
      const response = await api.get('/cities/list-all');
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Get cities by country ID
   * @param {number} countryId - Country ID
   * @returns {Promise} API response
   */
  async getCitiesByCountry(countryId) {
    try {
      const response = await api.get(`/cities/by-country/${countryId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Create new city
   * @param {Object} data - City data with name and countryId
   * @returns {Promise} API response
   */
  async createCity(data) {
    try {
      const response = await api.post('/cities/create-city', {
        name: data.name,
        countryId: data.countryId
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

const cityService = new CityService();
export default cityService;